import { call, put, takeEvery } from "redux-saga/effects";
import {
  SG_GET_LLM_MODEL_CONFIGS,
  GET_LLM_MODEL_CONFIGS,
  LLM_MODEL_CONFIGS_PENDING,
  SG_FETCH_LLM_MODEL_CONFIG,
  FETCH_LLM_MODEL_CONFIG,
  SG_ADD_LLM_MODEL_CONFIG,
  ADD_LLM_MODEL_CONFIG,
  SG_EDIT_LLM_MODEL_CONFIG,
  EDIT_LLM_MODEL_CONFIG,
  SG_DELETE_LLM_MODEL_CONFIG,
  DELETE_LLM_MODEL_CONFIG,
  SG_GET_LLM_USAGE_LOGS,
  GET_LLM_USAGE_LOGS,
  LLM_USAGE_LOGS_PENDING,
  SG_FETCH_LLM_USAGE_LOG,
  FETCH_LLM_USAGE_LOG,
  SG_ADD_LLM_USAGE_LOG,
  ADD_LLM_USAGE_LOG,
  SG_EDIT_LLM_USAGE_LOG,
  EDIT_LLM_USAGE_LOG,
  SG_DELETE_LLM_USAGE_LOG,
  DELETE_LLM_USAGE_LOG,
} from "../constants/actions";

import {
  GET_LLM_MODEL_CONFIGS as GET_LLM_MODEL_CONFIGS_API,
  FETCH_LLM_MODEL_CONFIG as FETCH_LLM_MODEL_CONFIG_API,
  ADD_LLM_MODEL_CONFIG as ADD_LLM_MODEL_CONFIG_API,
  EDIT_LLM_MODEL_CONFIG as EDIT_LLM_MODEL_CONFIG_API,
  DELETE_LLM_MODEL_CONFIG as DELETE_LLM_MODEL_CONFIG_API,
  GET_LLM_USAGE_LOGS as GET_LLM_USAGE_LOGS_API,
  FETCH_LLM_USAGE_LOG as FETCH_LLM_USAGE_LOG_API,
  ADD_LLM_USAGE_LOG as ADD_LLM_USAGE_LOG_API,
  EDIT_LLM_USAGE_LOG as EDIT_LLM_USAGE_LOG_API,
  DELETE_LLM_USAGE_LOG as DELETE_LLM_USAGE_LOG_API,
} from "../constants/llm_log.api";

// ==================== LLM MODEL CONFIGS ====================

// Get all LLM Model Configs
function* getLLMModelConfigs(action) {
  try {
    yield put({ type: LLM_MODEL_CONFIGS_PENDING });
    const { queryParams } = action.payload || {};
    const response = yield call(GET_LLM_MODEL_CONFIGS_API, queryParams);
    yield put({ type: GET_LLM_MODEL_CONFIGS, payload: response.data });
  } catch (error) {
    console.error("Error fetching LLM model configs:", error);
    yield put({
      type: GET_LLM_MODEL_CONFIGS,
      payload: { error: error.message },
    });
  }
}

// Fetch single LLM Model Config
function* fetchLLMModelConfig(action) {
  try {
    yield put({ type: LLM_MODEL_CONFIGS_PENDING });
    const response = yield call(FETCH_LLM_MODEL_CONFIG_API, action.payload);
    yield put({ type: FETCH_LLM_MODEL_CONFIG, payload: response.data });
  } catch (error) {
    console.error("Error fetching LLM model config:", error);
    yield put({
      type: FETCH_LLM_MODEL_CONFIG,
      payload: { error: error.message },
    });
  }
}

// Add LLM Model Config
function* addLLMModelConfig(action) {
  try {
    yield put({ type: LLM_MODEL_CONFIGS_PENDING });
    const response = yield call(ADD_LLM_MODEL_CONFIG_API, action.payload);
    yield put({ type: ADD_LLM_MODEL_CONFIG, payload: response.data });
    // Refresh the list
    yield put({ type: SG_GET_LLM_MODEL_CONFIGS, payload: {} });
  } catch (error) {
    console.error("Error adding LLM model config:", error);
    yield put({
      type: ADD_LLM_MODEL_CONFIG,
      payload: { error: error.message },
    });
  }
}

// Edit LLM Model Config
function* editLLMModelConfig(action) {
  try {
    yield put({ type: LLM_MODEL_CONFIGS_PENDING });
    const response = yield call(EDIT_LLM_MODEL_CONFIG_API, action.payload);
    yield put({ type: EDIT_LLM_MODEL_CONFIG, payload: response.data });
    // Refresh the list
    yield put({ type: SG_GET_LLM_MODEL_CONFIGS, payload: {} });
  } catch (error) {
    console.error("Error editing LLM model config:", error);
    yield put({
      type: EDIT_LLM_MODEL_CONFIG,
      payload: { error: error.message },
    });
  }
}

// Delete LLM Model Config
function* deleteLLMModelConfig(action) {
  try {
    yield put({ type: LLM_MODEL_CONFIGS_PENDING });
    yield call(DELETE_LLM_MODEL_CONFIG_API, action.payload);
    yield put({ type: DELETE_LLM_MODEL_CONFIG, payload: action.payload });
    // Refresh the list
    yield put({ type: SG_GET_LLM_MODEL_CONFIGS, payload: {} });
  } catch (error) {
    console.error("Error deleting LLM model config:", error);
    yield put({
      type: DELETE_LLM_MODEL_CONFIG,
      payload: { error: error.message },
    });
  }
}

// ==================== LLM USAGE LOGS ====================

// Get all LLM Usage Logs
function* getLLMUsageLogs(action) {
  try {
    yield put({ type: LLM_USAGE_LOGS_PENDING });
    const { queryParams } = action.payload || {};
    const response = yield call(GET_LLM_USAGE_LOGS_API, queryParams);
    yield put({ type: GET_LLM_USAGE_LOGS, payload: response.data });
  } catch (error) {
    console.error("Error fetching LLM usage logs:", error);
    yield put({
      type: GET_LLM_USAGE_LOGS,
      payload: { error: error.message },
    });
  }
}

// Fetch single LLM Usage Log
function* fetchLLMUsageLog(action) {
  try {
    yield put({ type: LLM_USAGE_LOGS_PENDING });
    const response = yield call(FETCH_LLM_USAGE_LOG_API, action.payload);
    yield put({ type: FETCH_LLM_USAGE_LOG, payload: response.data });
  } catch (error) {
    console.error("Error fetching LLM usage log:", error);
    yield put({
      type: FETCH_LLM_USAGE_LOG,
      payload: { error: error.message },
    });
  }
}

// Add LLM Usage Log
function* addLLMUsageLog(action) {
  try {
    yield put({ type: LLM_USAGE_LOGS_PENDING });
    const response = yield call(ADD_LLM_USAGE_LOG_API, action.payload);
    yield put({ type: ADD_LLM_USAGE_LOG, payload: response.data });
    // Refresh the list
    yield put({ type: SG_GET_LLM_USAGE_LOGS, payload: {} });
  } catch (error) {
    console.error("Error adding LLM usage log:", error);
    yield put({
      type: ADD_LLM_USAGE_LOG,
      payload: { error: error.message },
    });
  }
}

// Edit LLM Usage Log
function* editLLMUsageLog(action) {
  try {
    yield put({ type: LLM_USAGE_LOGS_PENDING });
    const response = yield call(EDIT_LLM_USAGE_LOG_API, action.payload);
    yield put({ type: EDIT_LLM_USAGE_LOG, payload: response.data });
    // Refresh the list
    yield put({ type: SG_GET_LLM_USAGE_LOGS, payload: {} });
  } catch (error) {
    console.error("Error editing LLM usage log:", error);
    yield put({
      type: EDIT_LLM_USAGE_LOG,
      payload: { error: error.message },
    });
  }
}

// Delete LLM Usage Log
function* deleteLLMUsageLog(action) {
  try {
    yield put({ type: LLM_USAGE_LOGS_PENDING });
    yield call(DELETE_LLM_USAGE_LOG_API, action.payload);
    yield put({ type: DELETE_LLM_USAGE_LOG, payload: action.payload });
    // Refresh the list
    yield put({ type: SG_GET_LLM_USAGE_LOGS, payload: {} });
  } catch (error) {
    console.error("Error deleting LLM usage log:", error);
    yield put({
      type: DELETE_LLM_USAGE_LOG,
      payload: { error: error.message },
    });
  }
}

// ==================== WATCHERS ====================

export default function* LLMLogSaga() {
  yield takeEvery(SG_GET_LLM_MODEL_CONFIGS, getLLMModelConfigs);
  yield takeEvery(SG_FETCH_LLM_MODEL_CONFIG, fetchLLMModelConfig);
  yield takeEvery(SG_ADD_LLM_MODEL_CONFIG, addLLMModelConfig);
  yield takeEvery(SG_EDIT_LLM_MODEL_CONFIG, editLLMModelConfig);
  yield takeEvery(SG_DELETE_LLM_MODEL_CONFIG, deleteLLMModelConfig);
  yield takeEvery(SG_GET_LLM_USAGE_LOGS, getLLMUsageLogs);
  yield takeEvery(SG_FETCH_LLM_USAGE_LOG, fetchLLMUsageLog);
  yield takeEvery(SG_ADD_LLM_USAGE_LOG, addLLMUsageLog);
  yield takeEvery(SG_EDIT_LLM_USAGE_LOG, editLLMUsageLog);
  yield takeEvery(SG_DELETE_LLM_USAGE_LOG, deleteLLMUsageLog);
}